import { Expose, Type } from "class-transformer";
import { IsBoolean, IsDateString, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Cashbox } from "@/models/api/Cashbox";

class Document {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  documentNumber!: string;
}

class FormOfPayment {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsBoolean()
  disableCashbox!: boolean;
  @Expose()
  @IsString()
  name!: string;
}

export class EditPayment {
  @Expose()
  @IsDateString()
  addDate!: string;
  @Expose()
  @Type(() => Cashbox)
  @ValidateNested()
  cashboxList!: Array<Cashbox>;
  @Expose()
  @IsOptional()
  @IsString()
  description!: null | string;
  @Expose()
  @IsString()
  documentCurrency!: string;
  @Expose()
  @Type(() => Document)
  @ValidateNested()
  documentsList!: Array<Document>;
  @Expose()
  @IsDateString()
  exchangeDate!: string;
  @Expose()
  @IsNumber()
  exchangeRate!: number;
  @Expose()
  @Type(() => FormOfPayment)
  @ValidateNested()
  formOfPaymentsList!: Array<FormOfPayment>;
  @Expose()
  @IsNumber()
  gross!: number;
  @Expose()
  @IsNumber()
  grossInCurrency!: number;
  @Expose()
  @IsNumber()
  grossInCurrencyLeftToPay!: number;
  @Expose()
  @IsNumber()
  grossLeftToPay!: number;
  @Expose()
  @IsBoolean()
  isExchangeDifference!: boolean;
  @Expose()
  @IsNumber()
  paymentAmount!: number;
  @Expose()
  @IsNumber()
  paymentAmountInCurrency!: number;
  @Expose()
  @IsNumber()
  paymentReferenceAmount!: number;
  @Expose()
  @IsNumber()
  referenceExchangeRate!: number;
  @Expose()
  @IsString()
  paymentCurrency!: string;
  @Expose()
  @IsBoolean()
  paymentFromBankStatement!: boolean;
  @Expose()
  @IsBoolean()
  paymentHasCashDocument!: boolean;
  @Expose()
  @IsNumber()
  paymentSumAmount!: number;
  @Expose()
  @IsNumber()
  paymentSumAmountInCurrency!: number;
  @Expose()
  @IsOptional()
  @IsNumber()
  selectedCashboxId!: null | number;
  @Expose()
  @IsString()
  selectedDocumentId!: string;
  @Expose()
  @IsNumber()
  selectedFormOfPaymentId!: number;
}

export class DataAfterAddPayment {
  @Expose()
  @IsString()
  documentId!: string;
  @Expose()
  @IsNumber()
  @IsOptional()
  cashboxId!: number | null;
  @Expose()
  @IsBoolean()
  canPrintCashDocument!: boolean;
  @Expose()
  @IsNumber()
  @IsOptional()
  paymentId!: number | null;
}
